export default __webpack_public_path__ + "static/media/emailSend.f20f67b1.svg";